var styles = {"mainInfoWrapper":"test-selection--main-info-wrapper","mainInfoWrapperCompact":"test-selection--main-info-wrapper-compact","addOn":"test-selection--add-on","helperText":"test-selection--helper-text"};

export { styles as default };
//# sourceMappingURL=TestSelection.module.esm.js.map
